import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupId = "/decisioning_studio_agents/:app_group_id";

// A successful POST adds a row to both the agents list and the use-cases digest.
export const decisioningStudioAgentsAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  "/decisioning_studio_agents/:app_group_id",
  "/offerfit/:app_group_id/use_cases",
];
